import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/enums/route-path.enum';
import { BandiService } from 'src/app/pages/services/bandi.service';
import { IncentiviService } from 'src/app/pages/services/incentivi.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-bandi-incentivi',
    templateUrl: './bandi-incentivi.component.html',
    styleUrls: ['./bandi-incentivi.component.scss'],
    standalone: false
})
export class BandiIncentiviComponent implements OnInit {
  newBandi?: number;
  newIncentivi?: number;

  constructor(
    private router: Router,
    private bandiService: BandiService,
    private incentiviService: IncentiviService
  ) { }

  ngOnInit(): void {
    this.getNewBandi()
    this.getNewIncentivi()
  }

  goToBandi() {
    this.router.navigate([RoutePath.BANDI]);
  }

  getNewBandi() {
    this.bandiService.countNewBandi().subscribe((res) => {
      this.newBandi = res;
    })
  }

  getNewIncentivi() {
    this.incentiviService.countNewIncentivi().subscribe((res) => {
      this.newIncentivi = res;
    })
  }

  goToIncentives() {
    this.router.navigate([RoutePath.INCENTIVI]);
  }
}
